







































































































































import { Component, Vue } from "vue-property-decorator";
import Header from '@/components/Header.vue';
import Api from '@/store/surelockApi';
import CustomerInfo from '@/components/surelock/CustomerInfo.vue';
import { CustomerInfoResponse } from '../types/surelockResponses';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc)
dayjs.extend(timezone)

@Component({
  components: {
    Header,
    CustomerInfo,
  },
})
export default class CreatePreservation extends Vue {
  links = [
    { text: 'Portal', to: '/' },
    { text: 'SureLock', to: '/surelock' },
    { text: 'Create Preservation', active: true },
  ];

  uid = '';
  sid = '';
  startDate = '';
  startTime = '';
  endDate = '';
  endTime = '';

  uuids = '';
  description = '';
  custInfo: CustomerInfoResponse = {}; 
  timeZone = 'America/New_York';

  hasVerifiedInfo = false;

  async getCustomerInfo(): Promise<void> {
    let customerInfo: CustomerInfoResponse;
    try {
      customerInfo = await Api.getCustomerInfo(this.uid, this.sid);
      this.custInfo = customerInfo;
      this.hasVerifiedInfo = true;
    } catch (err) {
      this.$toasted.error("Get Customer Info failed!", {
        position: "top-left",
        duration: 3000,
      });
    }
  }

  getUnixTimestamp(date: string, time: string, timeZone: string): number {
    const dateTime = `${date}T${time}`;
    const unixTime = dayjs.tz(dateTime, timeZone).unix()
    return unixTime;
  }

  validateInput(start: number, end: number, uuids: Array<string>): boolean {
    return !!parseInt(this.sid) && !isNaN(start) && !isNaN(end) && uuids.length !== 0;
  }

  async createPreservation(): Promise<void> {    
    if (!this.hasVerifiedInfo) {
      this.$toasted.error('Verify Customer Information First', {
        position: 'top-left',
        duration: 3000,
      });

      return;
    }

    const uuids = this.uuids.split('\n');
    this.timeZone = this.custInfo?.subscription?.location?.timeZone || 'America/New_York';
    const startTimestamp = this.getUnixTimestamp(this.startDate, this.startTime, this.timeZone);
    const endTimestamp = this.getUnixTimestamp(this.endDate, this.endTime, this.timeZone);

    const validInput = this.validateInput(startTimestamp, endTimestamp, uuids);

    if (!validInput) {
      this.$toasted.error('Invaild Input For Create Preservation', {
        position: 'top-left',
        duration: 3000,
      });
    }

    try {
      await Api.createPreservation(this.uid, this.sid, startTimestamp, endTimestamp, uuids, this.description);
      this.$toasted.info('Successfully Initiated Preservation', {
        position: 'top-left',
        duration: 3000,
      });
      this.$router.push('/surelock');      
    } catch (err) {
      this.$toasted.error('Create Preservation failed!', {
        position: 'top-left',
        duration: 3000,
      });
    }
  }

  populateUuids(uuids: Array<string>): void {
    this.uuids = uuids.join('\n');
  }
}

